module.exports = __webpack_public_path__ + "img/7.8838455.webp";